var _rect, _rect2, _text, _text2, _line, _line2, _circle, _circle2, _text3, _text4, _text5, _text6, _circle3, _text7, _text8, _circle4, _text9, _text0, _circle5, _text1, _text10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeStagesOverlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 340,
    viewBox: "0 0 220 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 340,
    rx: 16,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 220,
    height: 340,
    rx: 16,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 28,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 9,
    fontWeight: 700,
    letterSpacing: "0.1em"
  }, "RECIPE STAGES:")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 48,
    fill: "#000000",
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 15,
    fontWeight: 600
  }, "Spiced Roti Wraps")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 62,
    x2: 200,
    y2: 62,
    stroke: "rgba(0, 0, 0, 0.1)",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: 90,
    x2: 38,
    y2: 300,
    stroke: "rgba(0, 0, 0, 0.15)",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 100,
    r: 14,
    fill: "#335CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 100,
    r: 20,
    stroke: "#335CFF",
    strokeWidth: 2,
    strokeOpacity: 0.4,
    fill: "none"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 104,
    fill: "#FFFFFF",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    textAnchor: "middle"
  }, "1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 96,
    fill: "#000000",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "PREP")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 112,
    fill: "#335CFF",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 400
  }, "(Mise en place, chop")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 124,
    fill: "#335CFF",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 400
  }, "herbs, measure spices)")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 170,
    r: 14,
    fill: "rgba(0, 0, 0, 0.06)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 174,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    textAnchor: "middle"
  }, "2")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 174,
    fill: "#000000",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "COOK")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 220,
    r: 14,
    fill: "rgba(0, 0, 0, 0.06)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 224,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    textAnchor: "middle"
  }, "3")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 224,
    fill: "#000000",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "ASSEMBLE")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 270,
    r: 14,
    fill: "rgba(0, 0, 0, 0.06)"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 274,
    fill: "rgba(0, 0, 0, 0.5)",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    textAnchor: "middle"
  }, "4")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 274,
    fill: "#000000",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "SERVE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeStagesOverlay);
export default __webpack_public_path__ + "static/media/recipe-stages-overlay.c90ba42d75b0a79594c36d5ba36dce4f.svg";
export { ForwardRef as ReactComponent };